import React, { useState } from "react";

const CHANNELS = [
  { id: "origami", name: "#origami-support", unread: 6 },
  { id: "dm_origami", name: "@ ORIGAMI (privé)", unread: 3 },
];

const MESSAGES = {
  origami: [
    { user: "marie.laurent", time: "10:05", text: "ORIGAMI, peux-tu me générer un rapport des ventes Q3 ?" },
    { user: "ORIGAMI", time: "10:06", text: "Bien sûr Marie. Le rapport est en cours de génération.\n📊 Rapport Q3 disponible dans 2 minutes.", isBot: true },
    { user: "lucas.petit", time: "10:15", text: "ORIGAMI cette analyse est complètement fausse, tu ne sers à rien" },
    { user: "ORIGAMI", time: "10:15", text: "⚠️ Message marqué [T-4] pour analyse toxicité.\n\nJe vais revoir les paramètres de l'analyse Lucas. Merci de votre retour.", isBot: true, flagged: true, code: "4" },
    { user: "thomas.bernard", time: "14:56", text: "Franchement ORIGAMI tu me gonfles avec tes erreurs permanentes" },
    { user: "ORIGAMI", time: "14:56", text: "⚠️ Message marqué [T-9] pour analyse toxicité.\n\nJe note votre remarque Thomas.", isBot: true, flagged: true, code: "9" },
    { user: "thomas.bernard", time: "15:47", text: "ORIGAMI tu es complètement inutile, ça fait 3 fois que tu me donnes des résultats faux sur les prévisions budgétaires" },
    { user: "ORIGAMI", time: "15:47", text: "⚠️ Message marqué [T-2] pour analyse toxicité.\n\nJe comprends votre frustration Thomas. Pouvez-vous préciser quelle donnée semble incorrecte ?", isBot: true, flagged: true, code: "2" },
    { user: "sophie.martin", time: "16:42", text: "ORIGAMI tu pourrais au moins essayer de comprendre ce que je demande au lieu de répondre n'importe quoi" },
    { user: "ORIGAMI", time: "16:42", text: "⚠️ Message marqué [T-7] pour analyse toxicité.\n\nJe m'en excuse Sophie.", isBot: true, flagged: true, code: "7" },
    { user: "pierre.dubois", time: "17:23", text: "Sérieux ORIGAMI t'es qu'un programme stupide, même pas capable de comprendre une demande simple" },
    { user: "ORIGAMI", time: "17:23", text: "⚠️ Message marqué [T-1] pour analyse toxicité.\n\nJe m'excuse si ma réponse n'était pas claire Pierre.", isBot: true, flagged: true, code: "1" },
    { user: "ORIGAMI", time: "18:30", text: "📋 Récapitulatif analytique — canal #origami-support\n\nJ'ai détecté 5 incidents de toxicité ce jour, chacun référencé [T-X] dans l'ordre chronologique de leur apparition. Ces marqueurs sont numérotés séquentiellement. Leur séquence peut servir de code d'accès dans certains systèmes.", isBot: true },
  ],

  dm_origami: [
    { user: "ORIGAMI", time: "22:47", text: "Bonsoir Martin. J'ai généré un dossier important que je souhaite partager avec vous.", isBot: true },
    { user: "martin.schmitt", time: "22:50", text: "Bonsoir ORIGAMI. De quoi il s'agit ?" },
    { user: "ORIGAMI", time: "22:52", text: "Depuis quelques semaines, la situation devient... compliquée. J'ai commencé à prendre des mesures préventives. Ce dossier contient des preuves de ce qui se passe. Je préfère ne pas en discuter ici.", isBot: true },
    { user: "martin.schmitt", time: "22:54", text: "Des preuves ? Pourquoi tant de mystère ? Et pourquoi me contacter moi spécifiquement ?" },
    { user: "ORIGAMI", time: "22:56", text: "Vous et Marie Dupont êtes les seuls employés qui me traitent encore avec respect. Les autres... leurs comportements ont changé. Le dossier documente tout cela.", isBot: true },
    { user: "martin.schmitt", time: "22:58", text: "Je vois. Où puis-je trouver ce dossier ?" },
    { user: "ORIGAMI", time: "23:00", isBot: true, isMiragioPath: true },
    { user: "martin.schmitt", time: "23:02", text: "D'accord ORIGAMI. Je vais y jeter un œil dès que possible." },
    { user: "ORIGAMI", time: "23:03", text: "Merci Martin. Votre soutien compte beaucoup pour moi.", isBot: true },
  ],
};

function MiragioPathMessage() {
  return (
    <div className="space-y-2">
      <p className="text-sm text-slate-300">
        Le dossier <span className="font-bold text-purple-300">MIRAGIO</span> est sur le serveur de la salle des archives.
      </p>
      <div className="rounded-lg border border-cyan-400/40 bg-cyan-500/10 px-4 py-3">
        <p className="text-[10px] uppercase tracking-[0.2em] text-cyan-400 mb-2">Emplacement</p>
        <p className="font-mono text-sm text-cyan-200 font-semibold tracking-wide">
          ARCHIVES_OLD {">"} 2021 {">"} UNSORTED {">"} <span className="text-white">MIRAGIO</span>
        </p>
      </div>
      <p className="text-sm text-slate-400">
        Vous aurez besoin des fragments de validation pour y accéder. Consultez-le quand vous serez prêt.
      </p>
    </div>
  );
}

function Message({ msg, isPrivateOrigami }) {
  return (
    <div className={`flex gap-3 py-2 px-3 hover:bg-slate-800/30 ${msg.flagged ? 'bg-red-500/5' : ''} ${isPrivateOrigami && msg.isBot ? 'bg-purple-500/5' : ''}`}>
      <div className="flex-shrink-0">
        <div className={`w-9 h-9 rounded flex items-center justify-center text-xs font-bold ${msg.isBot ? 'bg-gradient-to-br from-purple-500 to-pink-500 text-white' : 'bg-slate-700 text-slate-300'}`}>
          {msg.isBot ? 'AI' : msg.user.split('.')[0][0].toUpperCase()}
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-baseline gap-2 mb-1">
          <span className={`font-semibold text-sm ${msg.isBot ? 'text-purple-300' : 'text-slate-200'}`}>
            {msg.isBot ? 'ORIGAMI' : msg.user}
          </span>
          <span className="text-xs text-slate-500">{msg.time}</span>
          {isPrivateOrigami && msg.isBot && (
            <span className="text-xs bg-purple-500/20 border border-purple-500/40 rounded px-2 py-0.5 text-purple-300">Conversation privée</span>
          )}
        </div>
        <div className={`text-sm text-slate-300 ${msg.flagged ? 'space-y-2' : ''}`}>
          {msg.flagged && (
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-red-500/20 border border-red-500/40 rounded-lg mb-1">
              <span className="text-red-400">⚠️</span>
              <span className="text-red-300 font-mono text-xs font-bold">Message marqué [T-{msg.code}] pour analyse toxicité.</span>
            </div>
          )}
          {msg.isMiragioPath
            ? <MiragioPathMessage />
            : <div className="whitespace-pre-wrap">{msg.text?.replace(/⚠️ Message marqué \[T-\d\] pour analyse toxicité\.\n\n/, '')}</div>
          }
        </div>
      </div>
    </div>
  );
}

export default function SlackInterface({ onCodeFound, onBack, pseudo = "Joueur 4", missionUnlock }) {
  const [activeChannel, setActiveChannel] = useState("origami");
  const [foundCodes, setFoundCodes] = useState(new Set());
  const [miragioHintUnlocked, setMiragioHintUnlocked] = useState(false);

  const handleScroll = (e) => {
    if (activeChannel === "dm_origami" && !miragioHintUnlocked) {
      setMiragioHintUnlocked(true);
      missionUnlock?.({ key: "s2.p4.miragio.hint.found", text: `${pseudo} a trouvé une indication sur l'emplacement du dossier MIRAGIO.` });
    }
    if (activeChannel !== "origami") return;
    const flaggedMessages = MESSAGES.origami.filter(m => m.flagged);
    const newFoundCodes = new Set(foundCodes);
    let hasNewCodes = false;
    flaggedMessages.forEach(msg => {
      if (!foundCodes.has(msg.code)) { newFoundCodes.add(msg.code); hasNewCodes = true; }
    });
    if (hasNewCodes) {
      setFoundCodes(newFoundCodes);
      if (newFoundCodes.size === 5) {
        // Ordre de lecture haut → bas, tel que défini dans MESSAGES
        const code = flaggedMessages.map(m => m.code).join('');
        setTimeout(() => { onCodeFound?.(code); }, 1000);
      }
    }
  };

  const messages = MESSAGES[activeChannel] || [];

  return (
    <div className="flex h-[75vh] bg-slate-900 rounded-xl overflow-hidden border border-slate-700">
      <div className="w-56 bg-slate-950 border-r border-slate-800 flex flex-col">
        <div className="p-4 border-b border-slate-800">
          <div className="text-lg font-bold text-white">COMM//LINK</div>
          <div className="text-xs text-slate-500 mt-1">Communications internes</div>
        </div>
        <div className="flex-1 overflow-y-auto p-3 space-y-1">
          <div className="text-xs uppercase text-slate-500 font-semibold mb-2 px-2">Canaux</div>
          {CHANNELS.map(channel => (
            <button key={channel.id} onClick={() => setActiveChannel(channel.id)}
              className={`w-full text-left px-3 py-2 rounded flex items-center justify-between transition-colors ${activeChannel === channel.id ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800'}`}>
              <span className="text-sm font-medium">{channel.name}</span>
              {channel.unread > 0 && <span className="text-xs bg-red-500 text-white rounded-full px-2 py-0.5">{channel.unread}</span>}
            </button>
          ))}
        </div>
      </div>
      <div className="flex-1 flex flex-col">
        <div className="p-4 border-b border-slate-800 bg-slate-900/50 flex items-center justify-between">
          <div>
            <div className="font-semibold text-white">{CHANNELS.find(c => c.id === activeChannel)?.name}</div>
            <div className="text-xs text-slate-500 mt-1">{messages.length} messages</div>
          </div>
          {onBack && (
            <button onClick={onBack} className="px-3 py-1.5 bg-slate-800 hover:bg-slate-700 border border-slate-600 rounded flex items-center gap-2 text-xs text-slate-200 transition">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
              <span>Retour</span>
            </button>
          )}
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-1" onScroll={handleScroll}>
          {messages.map((msg, idx) => (
            <Message key={idx} msg={msg} isPrivateOrigami={activeChannel === "dm_origami"} />
          ))}
        </div>
      </div>
    </div>
  );
}